// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { AgentOutputTurnBuf } from '../conversation/agent-output-turn-buf.js';
import { AgentStatusTurnBuf } from '../conversation/agent-status-turn-buf.js';
import { AgentTurnEndedReasonBuf } from '../conversation/agent-turn-ended-reason-buf.js';
import { DatagramErrorBuf } from '../datagram/datagram-error-buf.js';


export class AgentTurnBuf {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):AgentTurnBuf {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsAgentTurnBuf(bb:flatbuffers.ByteBuffer, obj?:AgentTurnBuf):AgentTurnBuf {
  return (obj || new AgentTurnBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsAgentTurnBuf(bb:flatbuffers.ByteBuffer, obj?:AgentTurnBuf):AgentTurnBuf {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new AgentTurnBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

connected():string|null
connected(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
connected(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

disconnected():string|null
disconnected(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
disconnected(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

output(obj?:AgentOutputTurnBuf):AgentOutputTurnBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? (obj || new AgentOutputTurnBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

status(obj?:AgentStatusTurnBuf):AgentStatusTurnBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? (obj || new AgentStatusTurnBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

errored(obj?:DatagramErrorBuf):DatagramErrorBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? (obj || new DatagramErrorBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

ended():AgentTurnEndedReasonBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? this.bb!.readUint32(this.bb_pos + offset) : null;
}

renamedConversation():string|null
renamedConversation(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
renamedConversation(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

static startAgentTurnBuf(builder:flatbuffers.Builder) {
  builder.startObject(7);
}

static addConnected(builder:flatbuffers.Builder, connectedOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, connectedOffset, 0);
}

static addDisconnected(builder:flatbuffers.Builder, disconnectedOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, disconnectedOffset, 0);
}

static addOutput(builder:flatbuffers.Builder, outputOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, outputOffset, 0);
}

static addStatus(builder:flatbuffers.Builder, statusOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, statusOffset, 0);
}

static addErrored(builder:flatbuffers.Builder, erroredOffset:flatbuffers.Offset) {
  builder.addFieldOffset(4, erroredOffset, 0);
}

static addEnded(builder:flatbuffers.Builder, ended:AgentTurnEndedReasonBuf) {
  builder.addFieldInt32(5, ended, null);
}

static addRenamedConversation(builder:flatbuffers.Builder, renamedConversationOffset:flatbuffers.Offset) {
  builder.addFieldOffset(6, renamedConversationOffset, 0);
}

static endAgentTurnBuf(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

}
